export const apiUrl = "https://suusje-server.herokuapp.com";

// https://cors-anywhere.herokuapp.com/
// "http://suusje-server.herokuapp.com"
// "https://suusje-server.herokuapp.com"
// "http://localhost:4000"
// process.env.API_URL ||

export const siteUrl = "https://suusje-pluusje.netlify.app";

export const DEFAULT_MESSAGE_TIMEOUT = 3000;
export const deliveryCosts = 5.95;
export const productIdForExtraProductsOne = 12;
export const productIdForExtraProductsTwo = 13;
